// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-clipboard-button .bolt-button.icon-only {
  padding: 8px;
}
.bolt-clipboard-button .bolt-button.icon-only.clipboard-button-inline {
  padding: 4px;
}

/*# sourceMappingURL=ClipboardButton.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/ClipboardButton/ClipboardButton.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/ClipboardButton/ClipboardButton.css"],"names":[],"mappings":"AAEI;EACI,YCsTI;ACvTZ;AFII;EACI,YC8SI;AChTZ;;AAEA,8CAA8C","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
